var map = {
	"./australian-restaurants_01.jpg": 8271,
	"./australian-restaurants_02.jpg": 1630,
	"./australian-tourism_01.jpg": 8736,
	"./australian-tourism_02.jpg": 9103,
	"./before-the-tour_01.jpg": 353,
	"./before-the-tour_02.jpg": 5572,
	"./boeing_01.jpg": 1426,
	"./boeing_02.jpg": 8509,
	"./boston-ivy_01.jpg": 4268,
	"./boston-ivy_02.jpg": 7485,
	"./brian-lock-music_01.jpg": 4705,
	"./brian-lock-music_02.jpg": 3382,
	"./cascades_01.jpg": 769,
	"./cascades_02.jpg": 1044,
	"./centtrip_01.jpg": 7818,
	"./centtrip_02.jpg": 3589,
	"./direct-line_01.jpg": 2873,
	"./direct-line_02.jpg": 6531,
	"./everest_01.jpg": 6219,
	"./everest_02.jpg": 8426,
	"./evolution-of-music_01.jpg": 8222,
	"./evolution-of-music_02.jpg": 5206,
	"./expert-women-project_01.jpg": 3919,
	"./expert-women-project_02.jpg": 7497,
	"./fury-cs_01.jpg": 1006,
	"./fury-cs_02.jpg": 3224,
	"./hyperlathe_01.jpg": 48,
	"./hyperlathe_02.jpg": 8575,
	"./invenias_01.jpg": 9900,
	"./invenias_02.jpg": 3403,
	"./ireland-tourism_01.jpg": 2943,
	"./ireland-tourism_02.jpg": 8889,
	"./kino-design_01.jpg": 2798,
	"./kino-design_02.jpg": 7525,
	"./lebara_01.jpg": 1971,
	"./lebara_02.jpg": 1447,
	"./mccann_01.jpg": 5474,
	"./mccann_02.jpg": 7387,
	"./mission-housing_01.jpg": 2227,
	"./mission-housing_02.jpg": 226,
	"./payment-card-solutions_01.jpg": 3740,
	"./payment-card-solutions_02.jpg": 154,
	"./princess-cruises_01.jpg": 926,
	"./princess-cruises_02.jpg": 6171,
	"./simplestream_01.jpg": 5318,
	"./simplestream_02.jpg": 7830,
	"./singapore-airlines_01.jpg": 9730,
	"./singapore-airlines_02.jpg": 808,
	"./soapy-business_01.jpg": 6384,
	"./soapy-business_02.jpg": 1652,
	"./the-mercy_01.jpg": 1908,
	"./the-mercy_02.jpg": 3396,
	"./treasure8_01.jpg": 2111,
	"./treasure8_02.jpg": 3543,
	"./yorkshire-bank_01.jpg": 1148,
	"./yorkshire-bank_02.jpg": 1237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2606;